import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Update `}<a parentName="p" {...{
        "href": "https://posthog.com/docs/integrate/server/python"
      }}>{`posthog-python`}</a>{` to version 1.4.3 or above to make use of the new functionality.`}</p>
    <p>{`To check a flag that's matching by companies, specify groups in relevant call:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-python"
      }}>{`if posthog.feature_enabled("new-groups-feature", "[distinct id]", groups={"company": "id:5"}):
    # do something
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      